import React from 'react'

function LightningIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2780_29284)">
        <path
          d="M7.01321 22.6661H5.01321C4.90104 22.6641 4.7912 22.6338 4.69385 22.5781C4.5965 22.5223 4.5148 22.4429 4.4563 22.3472C4.3978 22.2515 4.36441 22.1425 4.35921 22.0305C4.354 21.9184 4.37716 21.8068 4.42654 21.7061L8.36654 13.9994H3.99988C3.87973 14.0004 3.76155 13.969 3.65783 13.9083C3.55411 13.8477 3.4687 13.7601 3.41064 13.655C3.35258 13.5498 3.32403 13.4308 3.328 13.3108C3.33197 13.1907 3.36832 13.0739 3.43321 12.9728L10.5532 1.63944C10.6116 1.54835 10.6912 1.47282 10.7853 1.41939C10.8794 1.36597 10.9851 1.33624 11.0932 1.33278H20.0465C20.1797 1.32648 20.3116 1.36022 20.4254 1.42965C20.5391 1.49908 20.6295 1.60101 20.6847 1.72229C20.74 1.84356 20.7576 1.97861 20.7354 2.11001C20.7131 2.24141 20.652 2.36312 20.5599 2.45944L14.5199 9.33278H18.1065C18.2335 9.33545 18.3571 9.37435 18.4627 9.44488C18.5684 9.51542 18.6516 9.61466 18.7028 9.73093C18.7539 9.84719 18.7707 9.97564 18.7513 10.1012C18.7319 10.2267 18.6771 10.344 18.5932 10.4394L7.50654 22.4394C7.44481 22.5097 7.36899 22.5662 7.28399 22.6053C7.199 22.6443 7.10674 22.6651 7.01321 22.6661ZM6.11988 21.3328H6.72654L16.5732 10.6661H13.0599C12.9268 10.6724 12.7948 10.6387 12.681 10.5692C12.5673 10.4998 12.477 10.3979 12.4217 10.2766C12.3665 10.1553 12.3488 10.0203 12.3711 9.88887C12.3933 9.75748 12.4544 9.63576 12.5465 9.53944L18.5865 2.66611H11.4599L5.17988 12.6661H9.46654C9.57871 12.6681 9.68855 12.6984 9.7859 12.7542C9.88325 12.8099 9.96495 12.8893 10.0235 12.985C10.0819 13.0808 10.1153 13.1897 10.1205 13.3018C10.1257 13.4138 10.1026 13.5254 10.0532 13.6261L6.11988 21.3328Z"
          fill="#393D63"
        />
      </g>
      <defs>
        <clipPath id="clip0_2780_29284">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LightningIcon
